import { render, staticRenderFns } from "./ProxyBootstrap.vue?vue&type=template&id=20ff9376&"
import script from "./ProxyBootstrap.vue?vue&type=script&lang=js&"
export * from "./ProxyBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports